export default __webpack_public_path__ + "static/media/small_check.39f39397.svg";